import { fetchCompanyFundings } from '@/api/v4/organization-fundings.api';
import { fetchSpotlightCompanyFundings } from '@/api/v4/spotlight.api';
import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';
import { companyIdState } from '../company.state';
import { useAtomValue } from 'jotai';
import {
  type CompanyFetchMode,
  useCompanyFetchMode,
} from '../company-fetch-context';

const companyFundingsFetchers: Record<
  CompanyFetchMode,
  (companyId: string) => ReturnType<typeof fetchCompanyFundings>
> = {
  general: fetchCompanyFundings,
  spotlight: fetchSpotlightCompanyFundings,
};

export const useCompanyFundings = (companyIdParam?: string | null) => {
  const companyOverviewId = useAtomValue(companyIdState);
  const companyId = companyIdParam ?? companyOverviewId;
  const fetchMode = useCompanyFetchMode();

  return useQuery({
    queryKey: [QueryKey.CompanyFundings, fetchMode, companyId],
    queryFn: () => {
      if (!companyId) return null;
      return companyFundingsFetchers[fetchMode](companyId);
    },
    enabled: !!companyId,
  });
};
